var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddWidget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#506D85",
    fillRule: "nonzero",
    stroke: "#506D85",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.093 2h-6.9C2.535 2 2 2.535 2 3.193v6.9c0 .658.535 1.193 1.193 1.193h6.9c.658 0 1.193-.535 1.193-1.193v-6.9c0-.658-.535-1.193-1.193-1.193zm.478 8.093a.48.48 0 0 1-.478.478h-6.9a.48.48 0 0 1-.479-.478v-6.9a.48.48 0 0 1 .479-.479h6.9a.48.48 0 0 1 .478.479v6.9zM20.807 2h-6.9c-.658 0-1.193.535-1.193 1.193v6.9c0 .658.535 1.193 1.193 1.193h6.9c.658 0 1.193-.535 1.193-1.193v-6.9C22 2.535 21.465 2 20.807 2zm.479 8.093a.48.48 0 0 1-.479.478h-6.9a.48.48 0 0 1-.478-.478v-6.9a.48.48 0 0 1 .478-.479h6.9a.48.48 0 0 1 .479.479v6.9zM10.093 12.714h-6.9c-.658 0-1.193.535-1.193 1.193v6.9C2 21.465 2.535 22 3.193 22h6.9c.658 0 1.193-.535 1.193-1.193v-6.9c0-.658-.535-1.193-1.193-1.193zm.478 8.093a.48.48 0 0 1-.478.479h-6.9a.48.48 0 0 1-.479-.479v-6.9a.48.48 0 0 1 .479-.478h6.9a.48.48 0 0 1 .478.478v6.9zM21.643 17h-3.929v-3.929a.357.357 0 1 0-.714 0V17h-3.929a.357.357 0 1 0 0 .714H17v3.929a.357.357 0 1 0 .714 0v-3.929h3.929a.357.357 0 1 0 0-.714z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWidget);
export default __webpack_public_path__ + "static/media/add-widget.01aa53fad23b653c0d906158447a390c.svg";
export { ForwardRef as ReactComponent };